import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import ThemeContainer from '@/v2/components/layouts/ThemeContainer'
import { TabProvider } from '@/v2/contexts/TabsContext'
import { SnackbarProvider } from '@/v2/contexts/SnackbarContext'
import { AuthProvider } from '@/v2/contexts/AuthContext'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { initializeSentry } from '@/v2/utils/sentry'
import '@/v2/utils/globalFetch'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 20, // 20 seconds
    },
  },
})

const AppV2 = () => {
  useEffect(() => {
    initializeSentry()
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider>
        <TabProvider>
          <Router>
            <AuthProvider>
              <ThemeContainer />
            </AuthProvider>
          </Router>
        </TabProvider>
      </SnackbarProvider>
    </QueryClientProvider>
  )
}

export default AppV2
